const styles = {
  root: {
    backgroundColor: 'background.secondary',
    paddingY: { xs: 2, md: 4 },
    paddingX: { md: 4 },
  },

  accept: {
    '& .MuiFormControlLabel-label': {
      fontWeight: '600!important',
    },
  },

  formWrap: {
    padding: 5,
  },

  form: {
    marginBottom: 4,
  },

  submitButton: {
    display: 'flex',
    margin: '0 auto',
    width: { xs: '100%', sm: 348 },
  },

  divider: {
    margin: '0 auto',
    paddingY: 6,
  },

  termLink: {
    marginLeft: 1,
    color: 'primary.main',
  },

  circularProgressIcon: {
    marginRight: 1,
    '& .MuiCircularProgress-svg': {
      color: 'text.white',
    },
  },

  dialogContent: {
    textAlign: 'center',
    padding: { xs: 5, md: 8 },
  },

  dialogTitle: {
    fontWeight: 600,
    marginBottom: 4,
  },

  dialogParagraph: {
    marginBottom: 4,
  },

  alert: {
    marginBottom: 3,
  },

}

export default styles
